import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { AutocompleteControl } from 'components/_basic/Form/Autocomplete';

import { getIndustryGroupOptions, getIndustryOptions } from 'helpers/industryOperationOptions';

import {
  COMPANY_INDUSTRY_GROUP_FIELD_NAME,
  GLOBAL_FIELD_NAMES,
  INDUSTRY_FIELD_NAME,
  SECTOR_FIELD_NAME,
  SUB_SECTOR_FIELD_NAME,
  useGetGlobalInitialValues,
} from '../../form';
import { IIndustryDropdownProps as IProps } from '../types';

export const IndustryGroupDropdown: FC<IProps> = ({ disabled, id }) => {
  const globalInitialValues = useGetGlobalInitialValues();
  const { t, i18n } = useTranslation();
  const { control, setValue } = useFormContext();

  const [sectorValue, subSectorValue] = useWatch({ name: [SECTOR_FIELD_NAME, SUB_SECTOR_FIELD_NAME] });

  const industryGroupOptions =
    getIndustryGroupOptions(subSectorValue, i18n.language) ?? getIndustryGroupOptions(sectorValue, i18n.language) ?? [];
  const industryOptions =
    getIndustryOptions(subSectorValue, i18n.language) ?? getIndustryOptions(sectorValue, i18n.language) ?? [];

  const fieldChangeHandler = () =>
    setValue(INDUSTRY_FIELD_NAME, globalInitialValues[GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY]);

  if (((subSectorValue || sectorValue) && industryGroupOptions.length) || industryOptions.length) {
    return (
      <Grid item xs={12}>
        <AutocompleteControl
          control={control}
          label={t('industryGroup')}
          id={id ?? COMPANY_INDUSTRY_GROUP_FIELD_NAME}
          name={COMPANY_INDUSTRY_GROUP_FIELD_NAME}
          options={industryGroupOptions}
          disabled={disabled}
          onChange={fieldChangeHandler}
          onFieldClear={fieldChangeHandler}
        />
      </Grid>
    );
  }

  return null;
};
